import React, { ReactNode, useContext } from 'react';
import { InView } from 'react-intersection-observer';

import { PossibleTrigger } from 'components/ab-test/ab-test';
import AbTestContext from 'contexts/abTestContext';

interface Props {
  as?: 'div' | 'span';
  branch: string;
  children: ReactNode;
  className?: string;
}

const AbTestBranch = ({ as = 'div', branch, children, className }: Props) => {
  const context = useContext(AbTestContext);
  const { branch: testBranch, trigger, triggerCurrentTest } = context;
  const shouldRender = branch === testBranch;

  const content = React.createElement(as, { className }, children);
  const fallback = React.createElement(as, { className });

  if (trigger === PossibleTrigger.Visible && shouldRender) {
    return (
      <InView
        triggerOnce
        as={as}
        css={{ '&:empty': { display: 'none' } }}
        onChange={inView => inView && triggerCurrentTest()}
      >
        {children}
      </InView>
    );
  }

  return shouldRender ? content : fallback;
};

export default AbTestBranch;
